// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"C3-z","displaySixCardTiles":"D3-z"};